module.exports = __webpack_public_path__ + "static/media/6.2bea4c87.jpg";